module.exports = __webpack_public_path__ + "static/media/add.8fb5e7fa.svg";